export default "__VITE_ASSET__DMKLmNDj__"